import { type SEOHandle } from '@nasa-gcn/remix-seo'
import { type MetaFunction } from '@remix-run/node'
import { MapWelcome } from '#app/components/map-welcome'

export const handle: SEOHandle = {
	getSitemapEntries: () => [{ route: '/' }],
}

export const meta: MetaFunction = () => [
	{ title: 'Erda — claim a free place and share your story' },
	{
		name: 'description',
		content:
			'Find a meaningful place on the world map. Claim your first digital place for free, add a memory and share your story. Tree support is optional.',
	},
	{
		property: 'og:title',
		content: 'Every place has a story. Find yours on Erda.',
	},
	{
		property: 'og:description',
		content: 'One free place. Your place, your story. No card or renewal fee.',
	},
]
export default function Index() {
	return <MapWelcome />
}
